
export default {
  cellLeft: {},
  first: {},
  second: {},
  third: {},
  leftInfo: {},
  selectNewAvailButton: {},
  noDiscount: {},
  oldPriceNoMargin:{},
  defaultStyle: {
    display: 'flex',
    flexWrap:'wrap',
    alignItems:'center',
    justifyContent:'space-between',
    '& $cellLeft': {
      width: '50%',
      '@media (max-width:901px)': {
        padding: '10px 9px 10px 0px',
        width: '50%',
      },
      '@media (min-width: 902px)': {
        display:'flex',
        alignItems:'center'
      },
      '&:lang(ar)': {
        paddingRight: "24px",
        paddingLeft: "0",
        textAlign: "right",
        '@media (max-width:901px)': {
          padding: '10px 9px 10px 9px'
        }
      }
    },
    '& $first': {
      display: 'flex',
      flexDirection: 'column', 
      alignItems: 'flex-start',
      gap: '10px',
      minWidth: '162px',
      maxWidth: '162px',
      '@media (max-width:901px)': {
        marginBottom: '5px',
      },
      '& > span:last-of-type': {
        fontSize: '18px',
      }
    },
    '& $second': {
      display: 'table-cell',
      verticalAlign: 'middle',
      paddingLeft: '20px',
      outline: 'none',
      minWidth: '100px',
      boxSizing: 'border-box',
      '@media (max-width:901px)': {
        padding: '0',
      },
      '&:lang(ar)': {
        paddingRight: "20px",
        paddingLeft: "0",
        '@media (max-width:901px)': {
          paddingRight: 0
        }
      }
    },
    '& $third': {
      textAlign: 'right',
      position: 'relative',
      '& $leftInfo': {
        '& > button': {
          '@media (max-width:901px)': {
            display: 'inline-grid',
            textAlign: 'right',
          },
          '@media (min-width:901px)': {
            cursor: 'default',
          },
          '& > span:first-child': {
            '@media (min-width:901px)': {
              textAlign: 'right',
            }
          },
          '& > span$noDiscount': {
            '@media (min-width:901px)': {
              display: 'block',
              textAlign: 'right',
            }
          },
          '& > span$oldPriceNoMargin': {
            '@media (max-width:901px)': {
              marginRight: '0',
            },
          }
        },
        display: 'inline-block',
        verticalAlign: 'middle',
        fontWeight: 'normal',
        textAlign: 'right',
        paddingRight: '10px',
        '&:lang(ar)': {
          textAlign: "left",
          paddingLeft: "10px",
          paddingRight: "0",
          '@media (max-width:901px)': {
            marginRight: "0",
            marginLeft: "28px",
            borderLeft: "1px solid #d8d8d8",
            borderRight: "none"
          }
        },
        '@media (max-width:901px)': {
          borderRight: '1px solid #d8d8d8',
          marginRight: '28px',
          display: 'flex',
          flexDirection: 'column'
        },
      },
      '& $selectNewAvailButton': {
        fontFamily: 'Roboto, sans-serif',
        '@media (max-width:901px)': {
          display: 'inline-block',
          verticalAlign: 'middle',
          fontWeight: 'normal',
          background: 'transparent',
          border: 'none',
          height: '100%',
          width: '100%',
          position:'relative'
        },
        '& > span': {
          '@media (max-width:901px)': {
            color: data => data.mainColor,
            border: 'none',
            background: 'transparent',
            position: 'absolute',
            top: '50%',
            lineHeight: '0',
            right: '0',
            width: '29px'
          },
          '&:lang(ar)': {
            '@media (max-width:901px)': {
              right: 'auto',
              left: 0,
              transform: 'rotate(180deg)',
            }
          }
        }
      },
      '@media (max-width:901px)': {
        paddingRight: '0',
        display:'block',
        width: '40%'
      },
      '@media (min-width: 901px)': {
        width:'50%'
      },
      '@media (max-width: 1100px)': {
        maxWidth: '320px',
      },
      '@media (min-width: 1100px)': {
        width:'50%'
      },
      '&:lang(ar)': {
        paddingRight: "0",
        paddingLeft: "13px",
        textAlign: "left",
        '@media (max-width:901px)': {
          padding: "10px 9px 10px 0"
        }
      }
    },
    '&:lang(ar)': {
      direction: 'rtl'
    },
    '@media (min-width: 902px)': {
      alignItems: 'stretch',
    },
    '@media (max-width:901px)': {
      '&:has($detailPenaltyWrapper)': {
        '& $monoHotelTaxes': {
          order: '2',
          textAlign: 'left',
          marginTop: '2px',
          position: 'relative',
          maxWidth: 'unset',
          right: 'unset',
          top: 'unset'
        }
      }
    },
  },
  rateTooltip: {
    textAlign: 'center',
    position: 'absolute',
    maxWidth: '250px',
    display: 'table',
    backgroundColor: '#fc0',
    font: "11px 'Roboto',sans-serif",
    color: '#333',
    padding: '14px 9px',
    zIndex: '700',
    '@media (max-width:600px)': {
      paddingTop: '25px'
    }
  },
  ratePopover: {
    height: '10%',
    width: '10%'
  },
  withBorder: {
    borderBottom: '1px solid #D8D8D8',
    paddingBottom: '8px',
    marginBottom: '8px'
  },
  tooltipPointerStyle: {
    zIndex: '700',
    backgroundColor: '#fc0',
    width: '10px',
    height: '10px'
  },
  monoHotelTaxes:{
    font: "300 12px 'Roboto', sans-serif",
    color: '#767676',
    marginTop: '10px',
    flexBasis: '100%',
    textAlign: 'right',
    marginRight: '28px',
    marginBottom: '5px',
    '@media (min-width: 902px)': {
      marginRight:'0',
      marginBottom:'0',
      display:'block'
    },
    '&:lang(ar)': {
      textAlign: 'left',
      marginRight: '0',
      marginLeft: '28px',
      '@media (min-width: 801px)': {
        marginLeft: '0',
        marginRight: '28px',
      }
    }
  },
  buttonTableView:{
    '@media (max-width: 901px)': {
      display: 'none'
    }
  },
  monoContainerHotelTotal:{
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    '&$noDiscount':{
      gap: '10px',
      '@media (min-width:901px)': {
        width: '150px',
        gap: '0px',
      },
      '& > span$monoHotelTotalPriceText':{
        textAlign: 'right',
      }
    },
    '@media (min-width:901px)': {
      justifyContent: 'space-between',
    },
  },
  monoContainerHotelTotalExtended: {
    justifyContent: 'flex-end',
    gap: '5px',
  },
  monoHotelTotalPrice:{
    font: "bold 12px 'Roboto', sans-serif",
    color: '#333',
    marginRight:'0px',
    textAlign:'right',
  },
  monoHotelTotalPriceExtended:{
    width: 'auto',
  },
  monoHotelTotalPriceText:{
    font: "300 11px 'Roboto', sans-serif",
    color: '#9b9b9b',
  },
  monoHotelTotalPriceTextExtended:{
    width: 'auto',
  },
  oldPriceTransparent: {
    color: 'transparent',
    '@media (max-width:900px)': {
      display: 'none',
    },
  },
  leftInfoExtended: {
    '@media (max-width:900px)': {
      padding: '8px 10px 8px 0',
    },
  },
  detailPenaltyWrapper: {
    '@media (min-width: 901px)': {
      marginTop: '10px',
      marginBottom: '5px',
    },
  },
  rateDescription:{
    marginTop: '10px',
    '@media (min-width: 902px)': {
      paddingLeft: '20px',
      marginTop: '0',
    },
  },
  rateNameContainer:{},
  discountName:{
    minHeight: '16px',
    display: 'flex',
    alignItems: 'center'
  },
  discountBadgeContainer:{
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& $discountBadgeText':{
      background: data => data.mainColor,
      padding: '5px 10px',
      borderRadius: '5px',
      font: "700 11px 'Roboto',sans-serif",
      color: '#FFFFFF',
      textTransform: 'capitalize',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '5px',
      '& + span':{
        minHeight: '20px',
        display: 'flex',
        alignItems: 'center'
      }
    }
  },
  rateNameText:{
    marginRight: '8px',
  },
  pointerDiscountBadge:{
    background: data => data.mainColor,
  },
  discountBadgeTooltip:{
    background: data => data.mainColor,
    color: '#FFFFFF'
  },
  discountBadgeText:{},
  taxMessageWithRateDesc:{
    width: '100%',
    top: '60%',
    right: '28px',
    position: 'absolute',
    textAlign: 'right',
    marginTop: '14px',
    marginBottom: 'unset',
    marginRight: 'unset',
    maxWidth: '35%',
  }
};


